export class LoadCollections {
    public static readonly type = '[JobsPlacements] Load collections event';
}
